import { SVGProps } from 'react';

const IcEdit = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <g clip-path='url(#clip0_24222_5171)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0 23.4284H23.6116V21.1908H0V23.4284ZM8.26406 15.5968V12.5872L18.3863 3.59429L20.548 5.87777L11.2922 15.5968H8.26406ZM24 5.88L18.4513 0.571289L5.9029 11.643V17.8344H12.3028L24 5.88Z'
          fill={props.fill || '#1D2129'}
        />
      </g>
      <defs>
        <clipPath id='clip0_24222_5171'>
          <rect width='24' height='24' fill={props.fill || '#1D2129'} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IcEdit;
